import React from 'react';
import { motion } from 'framer-motion';
import clsx from 'clsx';
import { useFilterStore } from '../../store/filterStore';
import { useSound } from '../../hooks/useSound';
import { verticalConfig, isSingleVertical } from '../../utils/verticalConfig';

export const VerticalSelector: React.FC = () => {
  const { vertical, setVertical } = useFilterStore();
  const { play } = useSound();

  // Hide selector entirely when only one vertical is enabled
  if (isSingleVertical) return null;

  const handleVerticalChange = (newVertical: 'pathology' | 'mso') => {
    if (newVertical !== vertical) {
      play('tabSwitch');
      setVertical(newVertical);
    }
  };

  return (
    <div className="flex justify-center items-center gap-4">
      {/* Pathology Tab */}
      {verticalConfig.showLab && (
        <motion.button
          onClick={() => handleVerticalChange('pathology')}
          className={clsx(
            'px-8 py-4 rounded-lg font-bold text-base transition-all duration-200',
            'border-2 min-w-[280px]',
            vertical === 'pathology'
              ? 'bg-forest-green text-white border-forest-green'
              : 'bg-charcoal-gray text-light-gray border-medium-gray hover:border-light-blue'
          )}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <div className="text-left">
            <div className="font-bold">ANATOMICAL PATHOLOGY</div>
            <div className="text-sm mt-1 opacity-90">
              5,414 labs → 2-3 Platform + Roll-ups
            </div>
          </div>
        </motion.button>
      )}

      {/* MSO Tab */}
      {verticalConfig.showMso && (
        <motion.button
          onClick={() => handleVerticalChange('mso')}
          className={clsx(
            'px-8 py-4 rounded-lg font-bold text-base transition-all duration-200',
            'border-2 min-w-[280px]',
            vertical === 'mso'
              ? 'bg-forest-green text-white border-forest-green'
              : 'bg-charcoal-gray text-light-gray border-medium-gray hover:border-light-blue'
          )}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <div className="text-left">
            <div className="font-bold">MSO FORMATION</div>
            <div className="text-sm mt-1 opacity-90">
              8,200 practices → 76 targets across 9 markets
            </div>
          </div>
        </motion.button>
      )}
    </div>
  );
};
